import React from "react";
import CultureCapsuleImageVertical from "../CapsuleImageVertical/CultureCapsuleImageVertical";
import SectionTwoImage from "../../Assets/Images/about-us-section-two-3.png";
import SectionTwoImageMobile from "../../Assets/Images/about-us-section-two-mobile-3.png";
import AmericaFidRedImage from "../../Assets/Images/american-fidelity-red-logo.svg";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

import CultureIcon1 from "../../Assets/Images/culture-icon-1.svg";
import CultureIcon2 from "../../Assets/Images/culture-icon-2.svg";
import CultureIcon3 from "../../Assets/Images/culture-icon-3.svg";
import CultureIcon4 from "../../Assets/Images/culture-icon-4.svg";
import CultureIcon5 from "../../Assets/Images/culture-icon-5.svg";
import CultureIcon6 from "../../Assets/Images/culture-icon-6.svg";

import { Link } from "react-router-dom";

const Culture = () => {
  const translations = useTranslation(); // Get translations dynamically
  const awards = [
    {
      icon: CultureIcon6,
      title: translations.cultureFeatureOne,
    },
    {
      icon: CultureIcon1,
      title: translations.cultureFeatureTwo,
    },
    {
      icon: CultureIcon2,
      title: translations.cultureFeatureThree,
    },
    {
      icon: CultureIcon5,
      title: translations.cultureFeatureFour,
    },
    {
      icon: CultureIcon4,
      title: translations.cultureFeatureFive,
    },
  ];
  return (
    <>
      <div className="flex lg:flex-row flex-col justify-between">
        <div className="flex-1 mt-8 lg:mt-32 lg:max-w-[469px] animate__animated animate__fadeIn lg:order-none order-2 history-tab-content-vs animate__animated  animate__fadeInLeft  lg:pl-0 px-4">
          {/* <img src={AmericaFidRedImage} className="mb-6" alt="iambest-logo" />
          <p className="text-[14px] font-semibold mb-2 text-justify text-black">
            {translations.historyTitle}
          </p> */}
          <p className="text-[14px] mb-8 text-left text-black extra-para-vs">
            {translations.historyDescription}
          </p>
          <Link
            to="/about"
            className="text-[#00363C] font-bold bg-white  text-[14px]  rounded-full text-sm px-5 text-center mb-4 gotofaqbtn hover:bg-[#eeecf3] hidden lg:inline-flex extra-btn-font"
          >
            {translations.historyLearnMore}
          </Link>
        </div>
        <div className="flex-1 -mt-24 max-w-[220px] mx-16 hidden lg:block ">
          <div className=" ">
            <CultureCapsuleImageVertical image={SectionTwoImage} />
          </div>
        </div>

        <div className="flex-1 flex-wrap gap-4 lg:max-w-[420px] animate__animated animate__fadeInRight mt-4 lg:-mt-24 flex items-center lg:order-none order-1 culture-feat-wraper">
          <div className="grid grid-cols-2">
            {awards.map((award, index) => (
              <div
                key={index}
                className="py-4 px-4 rounded-lg culture-feat-grid"
              >
                <div className="w-[60px] h-[60px] lg:bg-[#F7F6F2] bg-[#ffffff] rounded-2xl flex justify-center items-center">
                  <img
                    src={award.icon}
                    alt=""
                    className=" flex-shrink-0 inline-flex"
                  />
                </div>
                <div className="text-sm mt-2">
                  <p
                    className=""
                    dangerouslySetInnerHTML={{ __html: award.title }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Culture;
